/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React from "react";

export const CemeteryOpeningHours: React.FC = () => {
    return (
        <div className="card card-open-hours jc-border-12">
            <div className="card-header card-header-bg">
                <p className="jc-txt-heading fs-5">Cemetery Opening Hours</p>
            </div>

            <div className="card-body p-0">
                <div className="jc-notification-wrapper p-3">
                    <div className="jc-notification d-flex align-items-center gap-2 jc-txt-body fs-6 px-3 py-2">
                        <img src="/images/icon-info.png" />
                        The cemeteries are closed on Shabbat, Jewish and South African holidays
                    </div>
                </div>
                <div className="d-flex">
                    <div className="location-1 jc-txt-body w-50 p-3">
                        <p className="fs-5 mb-2">Pinelands 1</p>
                        <div className="fs-7 d-flex flex-column">
                            <div className="d-flex justify-content-between">
                                <p><b>Sun</b></p><p>09:00 - 15:00</p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p><b>Mon</b></p><p>09:00 - 15:00</p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p><b>Tue</b></p><p>09:00 - 15:00</p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p><b>Wed</b></p><p>09:00 - 15:00</p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p><b>Thu</b></p><p>09:00 - 15:00</p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p><b>Fri</b></p><p>09:00 - 14:00</p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p><b>Sat</b></p><p>Closed</p>
                            </div>
                        </div>
                    </div>
                    <div className="location-2 jc-txt-body w-50 p-3">
                        <p className="fs-5 mb-2">Pinelands 2</p>
                        <div className="fs-7 d-flex flex-column">
                            <div className="d-flex justify-content-between">
                                <p><b>Sun</b></p><p>09:00 - 15:00</p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p><b>Mon</b></p><p>09:00 - 15:00</p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p><b>Tue</b></p><p>09:00 - 15:00</p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p><b>Wed</b></p><p>09:00 - 15:00</p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p><b>Thu</b></p><p>09:00 - 15:00</p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p><b>Fri</b></p><p>09:00 - 14:00</p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <p><b>Sat</b></p><p>Closed</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="card-footer d-flex justify-content-end">
                    <a href="#" className="btn btn-dark jc-txt-body jc-txt-light">Book a visit</a>
                </div> */}
                
            </div>
        </div>
    );
}